import React, { useEffect } from 'react';
import { QuickbaseIFrameContainer, quickbaseNavbarStoreSelector, useInventoryStore } from '@warehouse/quickbase';
import styled, { css } from 'styled-components';
import Card from '../../components/library/Card';

export function InventoryQuickbase() {
	const isLoading = useInventoryStore(quickbaseNavbarStoreSelector.isLoading);
	const isAuthenticated = useInventoryStore(quickbaseNavbarStoreSelector.isAuthenticated);
	const error = useInventoryStore(quickbaseNavbarStoreSelector.error);
	const embedUrl = useInventoryStore(quickbaseNavbarStoreSelector.embedUrl);
	const frameUrl = useInventoryStore(quickbaseNavbarStoreSelector.frameUrl);
	const showAuthOverlay = useInventoryStore(quickbaseNavbarStoreSelector.showAuthOverlay);
	const authFlow = useInventoryStore(quickbaseNavbarStoreSelector.authFlow);
	const actions = useInventoryStore(quickbaseNavbarStoreSelector.actions);
	const { loadEmbedUrl, authenticate, setShowAuthOverlay, dismissAuthOverlay, recoverSession } = actions;

	useEffect(() => {
		loadEmbedUrl();
	}, [loadEmbedUrl]);

	return (
		<Wrapper>
			<CardWrapper>
				<Card sx={{ minWidth: 275, overflow: 'hidden', height: '100%' }}>
					<QuickbaseIFrameContainer
						isLoading={isLoading}
						isAuthenticated={isAuthenticated}
						error={error}
						embedUrl={embedUrl}
						frameUrl={frameUrl}
						showAuthOverlay={showAuthOverlay}
						authenticate={authenticate}
						setShowAuthOverlay={setShowAuthOverlay}
						dismissAuthOverlay={dismissAuthOverlay}
						recoverSession={recoverSession}
						authFlow={authFlow}
						iFrameType="Inventory"
					/>
				</Card>
			</CardWrapper>
		</Wrapper>
	);
}
// Styled components
const Wrapper = styled.div(
	() => css`
		background-color: #dde0e3;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		width: 100%;
	`,
);

const CardWrapper = styled.div(
	({ theme }) => css`
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		gap: ${theme.spacing(2)};
		padding: ${theme.spacing(2)};
		width: 100%;
	`,
);
